import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HeroImage } from './components/HeroImage';
import { ChecklistSection } from './components/ChecklistSection';
import { PainSection } from './components/PainSection';
import { TurningPointSection } from './components/TurningPointSection';
import { CreatorSection } from './components/CreatorSection';
import { SolutionSection } from './components/SolutionSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PriceSection } from './components/PriceSection';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { FinalCta } from './components/FinalCta';
import { UrgencyToast } from './components/UrgencyToast';
import { ScrollProgress } from './components/ScrollProgress';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <ScrollProgress data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HeroImage data-id="element-4" />
        <ChecklistSection data-id="element-5" />
        <PainSection data-id="element-6" />
        <TurningPointSection data-id="element-7" />
        <CreatorSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <PriceSection data-id="element-11" />
        <TestimonialCarousel data-id="element-12" />
        <FinalCta data-id="element-13" />
      </main>
      <UrgencyToast data-id="element-14" />
    </div>;
}